import React from 'react';
import { Link } from 'react-router-dom';

export function ArchivalDisclaimer() {
    const triggerForm = () => {
        if (sessionStorage.getItem('afs')) {
            sessionStorage.removeItem('afs');
        }
    }

    return (
        <section id="ArchivalDisclaimer">
            <div className="container-fluid mt-3 disclaimer minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <img src="./images/icn-OnTopSchool.png" alt="" />
                                <h2 className="pageTitle mt-2">Archival Records</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-8 offset-md-2">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex justify-content-center">
                                    <div className="card-content">
                                        <div className="text-center mb-3">
                                            <h3 className="theme-color">Getting Started</h3>
                                        </div>
                                        <div className="theme-color">
                                            <p>
                                                You are about to leave the e-Request page and will be redirected to NAS' <a className="fw-bold" target="_self" href={process.env.REACT_APP_ARCHIVALONLINE_URL} title="Archives Online">Archives Online</a>, where you can request for archival records to view on-site, or request for reproduction of archival records.
                                            </p>
                                        </div>
                                        <div className="theme-color text-center">To learn more, click <Link className="fw-bold" to="/archival/guide">here</Link>.</div>
                                        <div className="text-center mt-3">
                                            <a onClick={() => triggerForm()} href={process.env.REACT_APP_ARCHIVALONLINE_URL} target="_self" title="Archives Online" className="btn btn-primary me-2">Proceed</a>
                                            <Link to={'/'} className="btn btn-secondary">Cancel</Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





